import { typography } from '@dentalux/ui-library-core'
import { Theme } from '@mui/material/styles'
import { createUseStyles } from 'react-jss'

export const iconContainerStyles = { display: 'flex', alignItems: 'center', justifyContent: 'center' }

export default createUseStyles((theme: Theme) => ({
  informationContainer: {
    display: 'flex',
    width: 314,
    alignItems: 'flex-start',
  },
  iconContainer: iconContainerStyles,
  icon: { color: theme.palette.primary['600'], width: 48, height: 48, marginRight: 16 },
  infoDetailsContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  header: {
    ...typography['Lato Emphasized 1'],
  },
  description: {
    ...typography['Lato Body 2'],
    marginTop: 6,
  },
  link: {
    ...typography['Lato Link 2'],
    marginTop: 6,
  },
}))
